module.exports = __webpack_public_path__ + "resources/img/item-3-2.8c3b5a77.png";